// extracted by mini-css-extract-plugin
module.exports = {"container":"UpdateUser_container__1Cg7d","box":"UpdateUser_box__2GWOy"};